import { ValueGetterParams } from 'ag-grid-community';
import {
  OfferItem,
  RoundingBasis,
} from '../../../../../shared/types';
import { getPriceRounded } from '../../../../../shared/getPriceRounded';

export const singlePaymentPriceGetter = (
  params: ValueGetterParams<OfferItem>,
  roundingBasis: RoundingBasis,
) => {
  if (!params.data) return;

  const {
    data: { singlePaymentPrice },
  } = params;
  return getPriceRounded(singlePaymentPrice, roundingBasis);
};
